import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import QuicksilverAppScreen from './QuicksilverAppScreen';
import { receivePageMetadata as receivePageMetadataImport } from '../../pageMetadata';

const mapDispatchToProps = dispatch => ({
  receivePageMetadata: metadata =>
    dispatch(receivePageMetadataImport(metadata)),
});

const FACEBOOK_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/social/anchor_sponsorships.png';
const TWITTER_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/social/anchor_sponsorships_twitter.png';

class QuicksilverAppScreenContainer extends React.Component {
  componentWillMount() {
    const { receivePageMetadata } = this.props;
    receivePageMetadata({
      title: 'Anchor Sponsorships',
      description: 'A new world for podcast advertising.',
      image: FACEBOOK_SOCIAL_IMAGE,
      twitterImage: TWITTER_SOCIAL_IMAGE,
    });
  }

  render() {
    return <QuicksilverAppScreen {...this.props} />;
  }
}

QuicksilverAppScreenContainer.propTypes = {
  receivePageMetadata: PropTypes.func.isRequired,
};

export default connect(
  null,
  mapDispatchToProps
)(QuicksilverAppScreenContainer);
